import PhotoSwipeLightbox from "photoswipe/lightbox";
import PhotoSwipe from "photoswipe";
import "photoswipe/style.css";

class PhotoSwipeService {
    constructor() {
        this.lightbox = null;
        this.changeCallback = null;
        this.closeCallback = null;
        this.rotate = 0;
    }

    open(items, index = 0) {
        this.close();
        this.lightbox = new PhotoSwipeLightbox({
            dataSource: items,

            pswpModule: PhotoSwipe,

            wheelToZoom: true,
            initialZoomLevel: "fit",
            secondaryZoomLevel: 2,
            maxZoomLevel: 3,

            preload: [1, 1],
            paddingFn: () => ({
                top: 20,
                bottom: 120,
                left: 20,
                right: 20
            })
        });
        this.lightbox.on("change",() => {
                const current = this.lightbox.pswp?.currIndex ?? 0;

            this.changeCallback?.(current);
                this.applyImageSize();
            }
        );
        this.lightbox.on("contentActivate",() => {
                this.applyImageSize();
            }
        );
        this.lightbox.on("close", () => {
                this.closeCallback?.();
            }
        );
        this.lightbox.init();
        this.lightbox.loadAndOpen(index);
    }
    applyImageSize() {
        const pswp = this.lightbox.pswp;
        const slide = pswp?.currSlide;
        const img = slide?.content?.element;

        if (!pswp || !slide || !img) {
            return;
        }

        if (slide.data._sizeApplied) {
            return;
        }

        const update = () => {
            const width = img.naturalWidth;
            const height = img.naturalHeight;

            if (!width || !height) {
                return;
            }

            slide.data.width = width;
            slide.data.height = height;

            slide.width = width;
            slide.height = height;

            slide.calculateSize();
            pswp.updateSize(true);

            const scale = Math.min(
                pswp.viewportSize.x / width,
                pswp.viewportSize.y / height,
                1
            );

            slide.zoomTo(scale,
                {
                    x: pswp.viewportSize.x / 2,
                    y: pswp.viewportSize.y / 2
                },
                0
            );

            slide.data._sizeApplied = true;
        };

        if (img.complete && img.naturalWidth) {
            update();
        } else {
            img.onload = update;
        }
    }

    close() {
        if (this.lightbox) {
            this.lightbox.destroy();
            this.lightbox = null;
        }
    }

    next() {
        this.lightbox?.pswp?.next();
    }

    prev() {
        this.lightbox?.pswp?.prev();
    }

    goTo(index) {
        this.lightbox?.pswp?.goTo(index);
    }

    onChange(callback) {
        this.changeCallback = callback;
    }

    onClose(callback) {
        this.closeCallback = callback;
    }

    rotateImage(deg = 90) {
        this.rotate += deg;
        if (this.rotate >= 360) {
            this.rotate = 0;
        }

        const pswp = this.lightbox?.pswp;
        const content = pswp?.currSlide?.content;

        if (content?.element) {
            content.element.style.transition = "transform .3s";
            content.element.style.transform = `rotate(${this.rotate}deg)`;
        }
    }
}
export default new PhotoSwipeService();